import { connect } from 'react-redux'
import RewardsHome from './rewards_home'

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RewardsHome)